
import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/20/solid'
import { ChartBarIcon } from '@heroicons/react/24/outline'
import { useSelector } from 'react-redux'
import { monthFormatter } from './Reportes'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Stats({ currentMonthData, lastMonthData, title, month, year }) {

  const option = useSelector(state => state.conta.info.Opcion)
  const currentMonthES = monthFormatter(month, year)
  const lastMonthES = monthFormatter(month - 1, year)
 
  const data = StatFormatter(currentMonthData, lastMonthData, month, option)

  return (
    <div className='bg-primarioMira rounded-lg p-5'>
      <div className='flex flex-row'>
        <ChartBarIcon
          className='h-14 w-14 mr-2 text-secundario'
        />
        <div>
          <h3 className="text-lg font-medium leading-6 text-white">Estadísticas generales</h3>
          <h4 className="text-lg font-medium leading-6 text-white">{title + ' - ' + lastMonthES + ' vs ' + currentMonthES + ', ' + year}</h4>
        </div>
      </div>      
      <p className="mt-1 text-sm text-grisMira">Comparación de ingreso por empresa</p>
      <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3 lg:grid-cols-4">
        {data.map((item) => (
          <div
            key={item.id}
            className="relative overflow-hidden rounded-lg bg-secundarioMira px-4 pt-5 pb-5 shadow-lg sm:px-6 sm:pt-6"
          >
            <dt className="text-base font-normal text-white">{item.empresa}</dt>
            <dd className="flex items-baseline justify-between flex-row flex-wrap gap-3">
              <div className={`flex items-baseline flex-col text-2xl font-semibold ${item.empresa !== 'Total' ? 'text-secundario' : 'text-green-600'}`}>
                {item.subtotal}
                <span className="ml-2 text-sm font-medium text-grisMira">Monto de {lastMonthES} {item.prevSubtotal}</span>
              </div>
              { item.change !== '0%' ? 
                <div
                    className={classNames(
                    item.changeType === 'increase' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800',
                    'inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium lg:mt-2 //lg:mt-0'
                    )}
                >
                    {item.changeType === 'increase' ? (
                    <ArrowUpIcon
                        className="-ml-1 mr-0.5 h-5 w-5 flex-shrink-0 self-center text-green-500"
                        aria-hidden="true"
                    />
                    ) : (
                    <ArrowDownIcon
                        className="-ml-1 mr-0.5 h-5 w-5 flex-shrink-0 self-center text-red-500"
                        aria-hidden="true"
                    />
                    )}

                    <span className="sr-only"> {item.changeType === 'increase' ? 'Increased' : 'Decreased'} by </span>
                    {item.change}
                </div>
                :
                <div className='inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium lg:mt-2 //lg:mt-0 bg-yellow-100 text-yellow-800'>
                    {item.change}
                </div>
              }

            </dd>
          </div>
        ))}
      </dl>
    </div>
  )
}

const getChange = (subtotal, prevSubtotal) => {
  const subtotalNum = parseFloat(subtotal?.slice(2).replace(/,/g, ''))
  const prevSubtotalNum = parseFloat(prevSubtotal?.slice(2).replace(/,/g, ''))
  const change = Math.round(((subtotalNum - prevSubtotalNum)/prevSubtotalNum)*100)
  
  if (Number.isNaN(change)) return "0%"
  
  return String(change) + '%'
}

const getChangeType = (change) => {
  
  let changeType
  const changeNum = Number(change.slice(0, -1))
  
  if(changeNum > 0){
    changeType = 'increase'
  }else{
    changeType = 'decrease'
  }

  return changeType
}

const StatFormatter = (currentMonthData, lastMonthData, currentMonth, queryOption) => {
  
  let data = []
  
  let i = 0
  currentMonthData.map((obj, index) =>
    data.push({
      id: i++,
      empresa: (index < (currentMonthData.length - 1) ? (queryOption === '0' ? obj.Empresa : obj.Sede) : 'Total'),
      subtotal: (index < (currentMonthData.length - 1) ? obj.Totales : obj.Total_Totales),
      prevSubtotal: index < (currentMonthData.length - 1) ? lastMonthData[index]?.Totales : lastMonthData[index]?.Total_Totales,
      change: index < (currentMonthData.length - 1) ? getChange(obj?.Totales, lastMonthData[index]?.Totales) : getChange(obj?.Total_Totales, lastMonthData[index]?.Total_Totales),
    })
  )

  data.map(stat => stat.changeType = getChangeType(stat.change)) 

  return data
}